module.exports = __webpack_public_path__ + "img/team_leader_6.23c5636e.png";